<template>
  <div class="make-your-mark">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="INNOVATION ALWAYS ON SITE"></ContentHeader>
        <section>
          <!-- <div class="blog-featured-image border mb-4">
            <img width="1024" height="576" src="http://thinktank.punctu8.co.za/wp-content/uploads/2018/04/make-your-mark.jpg" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt="" srcset="http://thinktank.punctu8.co.za/wp-content/uploads/2018/04/make-your-mark.jpg 1024w, http://thinktank.punctu8.co.za/wp-content/uploads/2018/04/make-your-mark-300x169.jpg 300w,  http://thinktank.punctu8.co.za/wp-content/uploads/2018/04/make-your-mark-768x432.jpg 768w"
            sizes="(max-width: 1024px) 100vw, 1024px">
          </div> -->
          <div class="row">
            <div class="col-md-12">
              <div v-if="!noIdeaSubmitted">
                <p>Your idea has been submitted</p>
                <button v-on:click="resetEntryFields()" type="button" name="button" class="btn btn-primary">Submit another idea</button>
              </div>
              <transition name="grow">
                <div v-if="noIdeaSubmitted">
                  <div v-html="makeYourMark.content.rendered"></div>
                  <hr>
                  <form v-on:submit.prevent="" class="make-mark-fields">
                    <div v-for="formField in makeMarkEntryFields" v-bind:key="formField.index">
                      <NominationField
                        :type="formField.type"
                        :description="formField.description"
                        :secondary-description="formField.secondaryDescription"
                        :is-required="formField.isRequired"
                        :checkbox-labels="formField.checkboxLabels"
                        v-on:updatedFieldContent="fieldUpdated($event)"
                        :displayField="formField.display_field"
                        :error-class="formField.errorClass">
                      </NominationField>
                    </div>
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                      <label for="terms" class="form-check-label">Accept the
                        <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                      </label>
                    </div>
                    <div class="form-group">
                      <button @click="submitMakeYourMarkEntry()" type="submit" class="btn btn-primary btn-lg">Submit idea</button>
                    </div>
                  </form>
                </div>
              </transition>
              <PreContentHeader :show-loading="creatingIdeaEntry" :error-message="creatingIdeaError"></PreContentHeader>
            </div>
            <div class="col-md make-your-marks">
              <div v-if="makeYourMarkEntries.length > 0 && entriesError === ''">
                <h4 class="blue-header">Latest entries</h4>
                <Ideas :ideas="makeYourMarkEntries" excerpt="true"></Ideas>
                <router-link to="/all-innovation-always-on" class="btn btn-outline-primary btn-block mt-3">View all entries</router-link>
              </div>
              <div v-if="entriesError !== ''" class="alert alert-warning" role="alert">
                {{entriesError}}
              </div>
            </div>
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import PreContentHeader from '@/components/PreContentHeader'
import NominationField from '@/components/NominationField'
export default {
  data () {
    return {
      noIdeaSubmitted: true,
      makeYourMark: '',
      makeYourMarkEntries: [],
      makeMarkEntryFields: [],
      makeMarkIdeaContent: [],
      termsCheckbox: false,
      contentReady: false,
      contentLoadError: '',
      entriesError: '',
      creatingIdeaEntry: false,
      creatingIdeaError: ''
    }
  },
  components: {
    ContentHeader,
    PreContentHeader,
    Ideas,
    NominationField
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    // Get content for Make Your mark challenge
    WordpressRestAPI.getViewContent('idea_challenge/19876')
      .then(response => {
        this.makeYourMark = response.data
        this.setMakeMarkFieldContent(response.data.idea_entry_fields[0][0])
        this.contentReady = true
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading Make your mark. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
    // Get Make your mark entries
    WordpressRestAPI.getViewContent('idea?idea_chalenge_category=10&per_page=2&_embed=true')
      .then(response => {
        this.makeYourMarkEntries = response.data
      })
      .catch(e => {
        this.entriesError = 'Oops! We had a problem with loading the Make your mark entries. Please try again later.'
        console.error(e)
      })
  },
  methods: {
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i < this.makeMarkIdeaContent.length; i++) {
        if (this.makeMarkIdeaContent[i].label === fieldDetails.label) {
          this.makeMarkIdeaContent[i].content = fieldDetails.content
          this.makeMarkIdeaContent[i].validated = fieldDetails.validated
          break
        }
      }
    },
    setMakeMarkFieldContent: function (makeMarkEntryFields) {
      this.makeMarkEntryFields = makeMarkEntryFields.map(function (x, index) {
        return {
          type: x.idea_entry_form_field_type,
          description: x.idea_entry_field_description,
          secondaryDescription: x.idea_entry_field_secondary_description,
          isRequired: x.idea_entry_required,
          checkboxLabels: x.idea_entry_checkbox_labels,
          errorClass: '',
          display_field: true,
          index: index + x.idea_entry_form_field_type}
      })
      this.makeMarkIdeaContent = makeMarkEntryFields.map(function (x) {
        return {label: x.idea_entry_field_description, content: '', required: x.idea_entry_required, validated: false, displayField: false}
      })
    },
    setMakeMarkTitle: function (fieldContent) {
      if (fieldContent.length > 60) {
        return fieldContent.substring(0, 60) + '...'
      } else {
        return fieldContent
      }
    },
    setPostContent: function () {
      var content = ''
      for (var i = 0; i < this.makeMarkIdeaContent.filter(x => x.label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):').length; i++) {
        content += '<strong>' + this.makeMarkIdeaContent[i].label + '</strong><br><p>' + this.makeMarkIdeaContent[i].content + '</p>'
      }
      return content
    },
    createIdeaPost: function () {
      this.creatingIdeaEntry = true
      var self = this
      var createIdea = {
        method: 'POST',
        data: {
          title: this.setMakeMarkTitle(this.makeMarkIdeaContent[0].content),
          idea_chalenge_category: [10],
          community_categories: this.makeYourMark.community_categories,
          status: 'publish',
          content: this.setPostContent(),
          total_likes: 0
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(createIdea, 'idea')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          var supportingDoc = self.makeMarkIdeaContent.filter(x => {
            return x.label.indexOf('supporting documentation') > -1 && x.content !== ''
          })
          self.uploadSupportingDocumentation(response.data.id, supportingDoc[0].content)
          self.noIdeaSubmitted = false
          self.termsAndConditions = false
          self.creatingIdeaEntry = false
        })
        .catch(function (e) {
          this.creatingIdeaError = 'Oops! We had a problem with uploading your entry. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    uploadSupportingDocumentation: function (postID, supportingDoc) {
      var self = this
      var formData = new FormData()
      formData.append('file', supportingDoc)
      formData.append('title', 'Supporting documentation for Team by ' + self.$store.getters.getUserName)
      formData.append('caption', 'Supporting documentation for Team by ' + self.$store.getters.getUserName)
      var uploadMedia = {
        method: 'POST',
        processData: false,
        contentType: false,
        data: formData,
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
        .then(function (response) {
          self.addMediaToIdeaPost(response.data.id, postID)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    addMediaToIdeaPost: function (mediaID, postID) {
      var sendNomination = {
        method: 'POST',
        data: {
          idea_supporting_documentation: mediaID
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'idea/' + postID)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    readyToSubmitIdea: function () {
      var contentPassedValidation = true
      for (var j = 0; j < this.makeMarkIdeaContent.length; j++) {
        this.makeMarkEntryFields[j].errorClass = ''
        if (this.makeMarkIdeaContent[j].required === 'false' && this.makeMarkIdeaContent[j].content === '' && !this.makeMarkIdeaContent[j].validated) {
          this.makeMarkIdeaContent[j].validated = true
        }
        if (this.makeMarkIdeaContent[j].validated === false) {
          contentPassedValidation = false
          this.makeMarkEntryFields[j].errorClass = 'field-not-validated'
        }
      }
      return this.termsCheckbox && contentPassedValidation
    },
    submitMakeYourMarkEntry: function () {
      if (this.readyToSubmitIdea()) {
        this.createIdeaPost()
      }
    },
    resetEntryFields: function () {
      this.noIdeaSubmitted = true
      this.setMakeMarkFieldContent(this.makeYourMark.idea_entry_fields[0][0])
    }
  }
}
</script>

<style lang="less">
.make-mark-fields {
  .row {
    display: block;
    div {
      width: 100%;
      max-width: 100%;
      label {
        text-align: left !important;
        color: rgba(0,0,0,.5) !important;
        small {
          font-size: 100%;
          color: black !important;
        }
      }
    }
  }
}
  .make-your-marks {
    .idea-entry {
      height: 110px !important;
      .idea-category-10 {
        display: none;
      }
      .author-pic {
        height: 75px;
        width: 75px;
      }
      h4 {
        font-size: 1em;
      }
      .ml-4 {
        img {
          width: 30px;
          height: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/MakeYourMarkChallenge.vue